// extracted by mini-css-extract-plugin
export default {"productGallery":"bQ-z","inQuickShop":"cQ-z"};